// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());





//

$(window).on('load resize', function(){
  $('.metier-wrap .bouton').each(function(){
    var hide = true;
    $(this).click(function(e){
      if(hide == true){
        $(this).closest('.metier').find('.content').show(200, function(){
          $('html, body').animate({
            scrollTop: ( $(this).closest('.metier').offset().top - 20 ),
          },200);
        });
        $(this).html('Fermer');
        hide = false;
      }
      else{
        $(this).closest('.metier').find('.content').hide(200);
        $(this).html('En lire +');
        hide = true;
      }
      e.preventDefault();
    });
  });
});


// tooltip
//

$('.equipe').mouseenter(function(){
  //var pos = $(this).position();

  $(this).find('.pat_tooltip div').addClass('show');//fadeIn();//is(':hidden') .css('top', (pos.top)+120 + 'px')
}).mouseleave(function(){
  $(this).find('.pat_tooltip div').removeClass('show');//fadeOut(); //.is(':visible')
});



